<div class="lum-page lum-page--full-height lum-page__card lum-c-stock-ag-table">
  <header class="lum-page-header">
    <h2 class="lum-page-header__heading">Stocks</h2>

    <div class="lum-page-header__actions">
      <button (click)="onResetFilters()" class="lum-button lum-button--secondary">
        <i class="fa fa-undo mr-2 d-none d-md-inline-block"></i>
        Reset Column Filters
      </button>
      <button
        (click)="onRefetchTableData()"
        class="lum-button lum-button--secondary"
      >
        <i class="fa fa-sync mr-2 d-none d-md-inline-block"></i>
        Refresh Table
      </button>
      <mat-select
        (selectionChange)="onGroupByChanged($event.value)"
        class="lum-select h-100 w-49"
        placeholder="Group By"
        [value]="groupBy"
      >
        <mat-option [value]="''">None</mat-option>
        <mat-option
          *ngFor="let group of groupByOptions; trackBy: trackByLabel"
          [value]="group.field"
          >{{ group.label }}</mat-option
        >
      </mat-select>
      <mat-checkbox
        class="lum-checkbox"
        [checked]="isOpenedSidebar"
        (change)="toggleSidebar()"
        >Show Sidebar</mat-checkbox
      >
      <lum-stock-actions></lum-stock-actions>
    </div>
  </header>

  <div class="lum-page-nav">
    <ng-content [select]="sideMenu"></ng-content>
  </div>

  <div
    class="lum-c-stock-ag-table__content lum-page__ag-grid"
    [ngClass]="{ 'is-open-details': isOpenedSidebar }"
  >
    <ag-grid-angular
      class="
        ag-theme-alpine ag-theme-lum ag-theme-lum--next lum-page__ag-grid__table lum-c-stock-ag-table__content-main
      "
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowData]="stocks$ | async"
      [rowSelection]="'multiple'"
      (rowSelected)="onRowSelected($event)"
      (selectionChanged)="onRowSelectionChanged()"
      [isRowSelectable]="isRowSelectable"
      [animateRows]="true"
      [gridOptions]="gridOptions"
      [suppressRowClickSelection]="true"
      [showLoadingOverlay]="loadingStocks$ | async"
      [getRowHeight]="getRowHeight"
      (gridReady)="onGridReady($event)"
      (columnMoved)="onColumnMoved($event)"
      (filterChanged)="onFilterChanged($event)"
      (sortChanged)="onSortChanged($event)"
      (columnVisible)="onColumnVisibleChanged($event)"
      [getRowStyle]="getRowStyle"
    ></ag-grid-angular>

    <div
      class="
        lum-paging lum-page__ag-grid__paging lum-c-stock-ag-table__content-foot
      "
    >
      <div class="lum-paging__jump-to-page">
        <label class="lum-label my-2">Page</label>
        <input
          #pageInput
          class="lum-paging__jump-to-page-input"
          type="number"
          [value]="goToPageValue"
          (input)="handleGoToPageInput(pageInput)"
          (keyup.enter)="gotoPage(pageInput.value)"
          lumInvalidNumberInput
          lumFocusHighlight
        />
        <label class="lum-label my-2">of {{ pagination.last_page }}</label>
      </div>
      <mat-paginator
        [length]="pagination.total || 0"
        [pageSize]="pagination.per_page"
        [pageSizeOptions]="paginationConfig.pageSizeOptions"
        [pageIndex]="(pagination.current_page || 1) - 1"
        (page)="onPaginationChange($event)"
        aria-label="Select page"
      ></mat-paginator>
    </div>

    <div
      *ngIf="isOpenedSidebar"
      class="lum-page__ag-grid__details lum-c-stock-ag-table__content-side"
    >
      <lum-stock-sidebar></lum-stock-sidebar>
    </div>
  </div>
</div>

<div
  class="overlay"
  lumAppLoader
  [loading]="(loadingStocks$ | async) || false"
  [classes]="'loading blur'"
></div>
